<!-- Graph with date picker -->
<div class="emma-card auto-width">
    <div class="filters">
        <mat-form-field class="data-field-select">
            <mat-select
                placeholder="{{ 'DEVICE.Data' | translate }}"
                [(value)]="dataField"
                [panelWidth]="null"
                panelClass="data-field-select-panel"
                (selectionChange)="reloadData()"
            >
                @for (field of sortedFields; track field) {
                    <mat-option [value]="field">{{ "FIELD." + field | translate }} </mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if (dataField != "spectrum_13_octave" && dataField != "spectrum_13_octave_1m") {
            <mat-form-field>
                <mat-select placeholder="{{ 'DEVICE.DateRange' | translate }}" [(value)]="dateRange" (selectionChange)="reloadData()">
                    <mat-option value="last15minutes">{{ "DEVICE.Last15Minutes" | translate }}</mat-option>
                    <mat-option value="lasthour">{{ "DEVICE.LastHour" | translate }}</mat-option>
                    <mat-option value="last4hours">{{ "DEVICE.Last4Hours" | translate }}</mat-option>
                    <mat-option value="last12hours">{{ "DEVICE.Last12Hours" | translate }}</mat-option>
                    <mat-option value="last24hours">{{ "DEVICE.Last24Hours" | translate }}</mat-option>
                    <mat-option value="custom">{{ "DEVICE.Custom" | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        }
        @if (dateRange == "custom") {
            <mat-form-field>
                <input
                    matInput
                    [matDatepicker]="start"
                    placeholder="{{ 'DEVICE.StartDate' | translate }}"
                    [(ngModel)]="startDate"
                    (dateChange)="updateEndDate($event)"
                    (dateInput)="updateEndDate($event)"
                />
                <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                <mat-datepicker #start (closed)="reloadData()"></mat-datepicker>
            </mat-form-field>
        }
        @if (dateRange == "custom") {
            <mat-form-field>
                <input
                    matInput
                    type="time"
                    [(ngModel)]="startTime"
                    placeholder="{{ 'DEVICE.StartTime' | translate }}"
                    step="300"
                    (change)="reloadData()"
                />
            </mat-form-field>
        }
        @if (dateRange == "custom") {
            <mat-form-field>
                <input
                    matInput
                    [matDatepicker]="end"
                    placeholder="{{ 'DEVICE.EndDate' | translate }}"
                    [min]="endDateMin"
                    [max]="endDateMax"
                    [(ngModel)]="endDate"
                />
                <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                <mat-datepicker #end (closed)="reloadData()"></mat-datepicker>
            </mat-form-field>
        }
        @if (dateRange == "custom") {
            <mat-form-field>
                <input
                    matInput
                    type="time"
                    [(ngModel)]="endTime"
                    placeholder="{{ 'DEVICE.EndTime' | translate }}"
                    step="300"
                    (change)="reloadData()"
                />
            </mat-form-field>
        }
        @if (
            dataField != "spectrum_13_octave" &&
            dataField != "spectrum_13_octave_1m" &&
            dataField != "battery" &&
            dataField != "free_storage"
        ) {
            <mat-form-field>
                <mat-select
                    placeholder="{{ 'DEVICE.DataAggregation' | translate }}"
                    [(value)]="groupingData"
                    (selectionChange)="reloadData()"
                >
                    @if (enableInstantValues) {
                        <mat-option value="no">{{ "DEVICE.NoAggregation" | translate }}</mat-option>
                    }
                    <mat-option value="5minutes">{{ "DEVICE.Minutes5" | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        }
        @if (enableLiveData) {
            <mat-slide-toggle [(ngModel)]="liveData">{{ "DEVICE.LiveUpdate" | translate }}</mat-slide-toggle>
        }
        @if (showPercentileControls && percentilesAvailable) {
            <mat-slide-toggle [(ngModel)]="showL10" (change)="reloadGraph()">
                {{ "DEVICE.ShowL10" | translate }}
            </mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="showL90" (change)="reloadGraph()">
                {{ "DEVICE.ShowL90" | translate }}
            </mat-slide-toggle>
        }
        @if (hasLinkedSpectrum) {
            <mat-slide-toggle [(ngModel)]="showLinkedSpectrum" (change)="reloadGraph()">
                {{ "DEVICE.ShowSpectrum" | translate }}
            </mat-slide-toggle>
        }
    </div>

    @if ((dataField == "spectrum_13_octave" || dataField == "spectrum_13_octave_1m") && showChart) {
        <div class="chart-shell">
            <highcharts-chart
                [Highcharts]="HighchartsCore"
                [constructorType]="spectrumChart.constructor"
                [options]="spectrumChart.options"
                [(update)]="spectrumChart.update"
                style="width: 100%; display: block"
                [callbackFunction]="chartCallback"
            ></highcharts-chart>
        </div>
    }
    @if (dataField != "spectrum_13_octave" && dataField != "spectrum_13_octave_1m" && showChart && activeChartConfig; as chart) {
        <div class="chart-shell">
            <highcharts-chart
                [Highcharts]="Highstock"
                [constructorType]="chart.constructor"
                [options]="chart.options"
                [(update)]="activeChartConfig.update"
                style="width: 100%; display: block"
                [oneToOne]="true"
                [callbackFunction]="chartCallback"
            ></highcharts-chart>
            @if (showLinkedSpectrum && selectedLinkedSpectrumSnapshot; as snapshot) {
                <div class="linked-spectrum">
                    <div class="linked-spectrum__header">
                        {{ snapshot.timestamp | date: "medium" }}
                    </div>
                    <highcharts-chart
                        [Highcharts]="HighchartsCore"
                        [constructorType]="linkedSpectrumChart.constructor"
                        [options]="linkedSpectrumChart.options"
                        [(update)]="linkedSpectrumChart.update"
                        style="width: 100%; display: block"
                    ></highcharts-chart>
                </div>
            }
        </div>
    }
</div>

<div class="emma-card auto-width card-export">
    <div class="filters">
        <mat-form-field class="data-field-select">
            <mat-select
                placeholder="{{ 'DEVICE.Data' | translate }}"
                [(value)]="dataFieldExport"
                [panelWidth]="null"
                panelClass="data-field-select-panel"
            >
                @for (field of sortedFields; track field) {
                    <mat-option [value]="field">{{ "FIELD." + field | translate }} </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <input matInput [matDatepicker]="start" placeholder="{{ 'DEVICE.StartDate' | translate }}" [(ngModel)]="startDateExport" />
            <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
            <mat-datepicker #start></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <input matInput type="time" [(ngModel)]="startTimeExport" placeholder="{{ 'DEVICE.StartTime' | translate }}" step="300" />
        </mat-form-field>
        <mat-form-field>
            <input matInput [matDatepicker]="end" placeholder="{{ 'DEVICE.EndDate' | translate }}" [(ngModel)]="endDateExport" />
            <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <input matInput type="time" [(ngModel)]="endTimeExport" placeholder="{{ 'DEVICE.EndTime' | translate }}" step="300" />
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{ 'DEVICE.DataAggregation' | translate }}" [(value)]="groupingDataExport">
                <mat-option value="no">{{ "DEVICE.NoAggregation" | translate }}</mat-option>
                <mat-option value="5minutes">{{ "DEVICE.Minutes5" | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div style="text-align: center" class="print-hide">
        @if (dataField != "spectrum_13_octave" && dataField != "spectrum_13_octave_1m") {
            <button mat-raised-button class="download-button" (click)="downloadDataExport()" [disabled]="exporting">
                @if (exporting) {
                    <mat-spinner [diameter]="25"></mat-spinner>
                }
                @if (!exporting) {
                    <mat-icon>cloud_download</mat-icon>
                }
                {{ "DEVICE.Download" | translate }}
            </button>
        }
    </div>
</div>
